var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayNotifications.length > 0
    ? _c(
        "div",
        [
          _vm._l(_vm.displayNotifications, function (notification) {
            return [
              _c(notification, {
                tag: "Component",
                attrs: { data: _vm.notificationData[notification] },
                on: { "dismiss-notification": _vm.dismissNotification },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }